module.exports = __webpack_public_path__ + "static/media/gb-wls.07b6cb31.jpeg";